let global = {};

export {global};

export function makeGlobal(path, funcToMakeGlobal) {
    let putIn = global,
        pathSplit = path.split("."),
        lastPath = pathSplit.pop();

    for (let i in pathSplit) {
        if (typeof putIn[pathSplit[i]] == 'undefined') putIn[pathSplit[i]] = {};
        putIn = putIn[pathSplit[i]];
    }

    putIn[lastPath] = funcToMakeGlobal;
}

